import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "address-page"
};
const _hoisted_2 = { class: "ap-intro" };
const _hoisted_3 = { class: "ap-subtitle" };
const _hoisted_4 = {
    key: 0,
    class: "ap-section"
};
const _hoisted_5 = {
    key: 1,
    class: "ap-section"
};
const _hoisted_6 = {
    key: 0,
    class: "ap-preview"
};
const _hoisted_7 = { class: "ap-preview-value" };
const _hoisted_8 = { class: "anchor-bottom-no-nav" };
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import AddressLookup from './elements/AddressLookup.vue';
import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddressPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer, addAddress } = useCustomer();
        const address = ref(null);
        const manual = ref(false);
        const saving = ref(false);
        const inputSections = ref(null);
        const manualSections = ref([]);
        const existing = computed(() => state.customer?.person?.addresses?.[0] || null);
        const formattedAddress = computed(() => {
            if (!address.value)
                return '';
            const a = address.value;
            return [a.line1, a.line2, a.line3, a.town, a.postCode].filter(Boolean).join(', ');
        });
        const canSave = computed(() => {
            if (manual.value) {
                return !!(findFieldValue('Address line 1') && findFieldValue('Town/City') && findFieldValue('Postcode'));
            }
            return !!(address.value && address.value.postCode);
        });
        function enableManual() {
            const a = address.value || existing.value || {};
            manualSections.value = [{
                    fields: [
                        { label: 'Address line 1', type: 'text', value: a.line1 || '', required: true, validationText: 'Please enter the first line of your address' },
                        { label: 'Address line 2', type: 'text', value: a.line2 || '' },
                        { label: 'Town/City', type: 'text', value: a.town || '', required: true, validationText: 'Please enter your town or city' },
                        { label: 'Postcode', type: 'text', value: a.postCode || '', required: true, validationText: 'Please enter your postcode' },
                    ]
                }];
            manual.value = true;
        }
        function findFieldValue(label) {
            for (const section of manualSections.value) {
                for (const field of section.fields) {
                    if (field.label === label)
                        return field.value || null;
                }
            }
            return null;
        }
        function buildAddress() {
            if (!manual.value) {
                const a = address.value;
                return { line1: a.line1 || null, line2: a.line2 || null, line3: a.line3 || null, town: a.town || null, postCode: a.postCode || null };
            }
            return {
                line1: findFieldValue('Address line 1'),
                line2: findFieldValue('Address line 2'),
                line3: null,
                town: findFieldValue('Town/City'),
                postCode: findFieldValue('Postcode'),
            };
        }
        function save() {
            if (!canSave.value)
                return;
            saving.value = true;
            addAddress(buildAddress(), () => {
                getCustomer(null, false);
                router.back();
            });
        }
        onMounted(() => {
            getCustomer();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Your address" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "ap-heading" }, "Where do you live?", -1)),
                                    _createElementVNode("p", _hoisted_3, "We need your full address" + _toDisplayString(existing.value?.postCode ? ' for ' + existing.value.postCode.toUpperCase() : '') + " in order for you to pay by bank.", 1)
                                ]),
                                (!manual.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(AddressLookup, {
                                            theme: "light",
                                            value: existing.value,
                                            modelValue: address.value,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((address).value = $event))
                                        }, null, 8, ["value", "modelValue"]),
                                        _createElementVNode("div", {
                                            class: "ap-manual-link",
                                            onClick: enableManual
                                        }, "Can't find it? Enter manually")
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createVNode(InputSections, {
                                            ref_key: "inputSections",
                                            ref: inputSections,
                                            sections: manualSections.value,
                                            theme: "light"
                                        }, null, 8, ["sections"]),
                                        _createElementVNode("div", {
                                            class: "ap-manual-link",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (manual.value = false))
                                        }, "Search by postcode instead")
                                    ])),
                                _createVNode(_Transition, null, {
                                    default: _withCtx(() => [
                                        (!manual.value && address.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "ap-preview-label" }, "Selected address", -1)),
                                                _createElementVNode("div", _hoisted_7, _toDisplayString(formattedAddress.value), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(MGButton, {
                                        text: "Save address",
                                        disabled: !canSave.value || saving.value,
                                        fullWidth: true,
                                        onClick: save
                                    }, null, 8, ["disabled"])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
